module.exports = __webpack_public_path__ + "images/get-credit-bg-min-8c182465.svg";